import styled from 'styled-components';

export const MobileWarningContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MobileWarningText = styled.span`
  text-align: center;
`;
